/**
 * Labstep
 *
 * @desc Create Form for resource
 */

import EntityFormCreateTemplatable from 'labstep-web/components/Entity/Form/Create/Templatable';
import type React from 'react';
import type { IResourceFormCreateProps } from './types';

export const ResourceFormCreate: React.FC<
  IResourceFormCreateProps
> = ({ defaultValues, options }) => (
  <EntityFormCreateTemplatable
    entityName="resource"
    options={options}
    defaultValues={defaultValues}
  />
);
